var map = {
	"./audience-groups-full.png": 24,
	"./faces-full.png": 25,
	"./faces-small.png": 26,
	"./persona-full.png": 27,
	"./persona-sketches-full.png": 28,
	"./persona-small.png": 29,
	"./pizza-full.png": 30,
	"./pizza-small.png": 31,
	"./research-schedule-full.png": 32,
	"./retro-full.png": 33,
	"./retro-small.png": 34,
	"./tradar-full.png": 35,
	"./tradar-small.png": 36,
	"./ux-score-full.png": 37,
	"./ux-score-small.png": 38,
	"./video-call-full.png": 39,
	"./video-call-small.png": 40,
	"./website-full.png": 41,
	"./website-small.png": 42,
	"./website_on_phone.jpg": 43,
	"./wip-full.png": 44,
	"./wip-small.png": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;